<template>
  <div>
    <div class="l-container">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
  },
  data () {
    return {
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
    })
  },
  methods: {
  },
  mounted () {
  },
  route: {
  }
}
</script>

<style lang='scss'>
</style>



// WEBPACK FOOTER //
// Print.vue?7fc9afab